import {faAddressCard} from '@fortawesome/free-solid-svg-icons/faAddressCard';
import {faCashRegister} from '@fortawesome/free-solid-svg-icons/faCashRegister';
import {faIndustry} from '@fortawesome/free-solid-svg-icons/faIndustry';
import {faPortrait} from '@fortawesome/free-solid-svg-icons/faPortrait';
import {faReceipt} from '@fortawesome/free-solid-svg-icons/faReceipt';
import {faTags} from '@fortawesome/free-solid-svg-icons/faTags';
import {faUsers} from '@fortawesome/free-solid-svg-icons/faUsers';
import {faBell} from '@fortawesome/free-solid-svg-icons/faBell';
import {faStarHalfAlt} from '@fortawesome/free-solid-svg-icons/faStarHalfAlt';
import {AUTH_TOKEN_ACCESS, FILE_TYPE, PASSWORD_MAX_LENGTH, ROLES} from '../common/constants';
import moment from 'moment';
import {faFileExport} from '@fortawesome/free-solid-svg-icons/faFileExport';
import {faFileInvoice} from '@fortawesome/free-solid-svg-icons/faFileInvoice';
import {faStore} from '@fortawesome/free-solid-svg-icons/faStore';
import {faChartLine} from '@fortawesome/free-solid-svg-icons/faChartLine';



const makeCancelable = promise => {
  let hasCanceled_ = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      val => (hasCanceled_ ? reject({isCanceled: true}) : resolve(val)),
      error => (hasCanceled_ ? reject({isCanceled: true}) : reject(error)),
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    },
  };
};

export {makeCancelable as default};

export const validateEmail = email => {
  const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regexp.test(email);
};

export const logout = (client = null) => {
  localStorage.removeItem(AUTH_TOKEN_ACCESS);
  if (client) {
    client.cache.reset();
  }
};

export const createUserAuthTokens = result => {
  localStorage.setItem(AUTH_TOKEN_ACCESS, result.token);
};

export const getAccessToken = () => {
  return localStorage.getItem(AUTH_TOKEN_ACCESS);
};

export const checkPasswordsMatch = (pass, confirm) => {
  return pass === confirm;
};

export const validatePassword = pass => {
  return pass.length >= PASSWORD_MAX_LENGTH && /\d/.test(pass);
};

export function getRoutes(role = ROLES.USER) {
  let routes;
  switch (role) {
  case ROLES.ADMIN:
    routes = [
      {to: '/admin/dashboard', name: 'dashboard', icon: faChartLine},
      {to: '/admin/brands', name: 'brands', icon: faIndustry},
      {to: '/admin/merchants', name: 'merchants', icon: faPortrait},
      {to: '/admin/checkouts', name: 'checkouts', icon: faCashRegister},
      {to: '/admin/tickets', name: 'tickets', icon: faReceipt},
      {to: '/admin/tags', name: 'tags', icon: faTags},
      {to: '/admin/users', name: 'users', icon: faUsers},
      {to: '/admin/admins', name: 'admins', icon: faUsers},
      {to: '/admin/billing', name: 'billing', icon: faReceipt},
      {to: '/admin/products/notifications', name: 'notifications', icon: faBell},
    ];
    break;
  case ROLES.MERCHANT:
    routes = [
      {to: '/admin/dashboard', name: 'dashboard', icon: faChartLine},
      {to: '/admin/profile', name: 'profile', icon: faAddressCard},
      {to: '/admin/checkouts', name: 'checkouts', icon: faCashRegister},
      {to: '/admin/tickets', name: 'tickets', icon: faReceipt},
      {to: '/admin/tickets/reviews', name: 'reviews', icon: faStarHalfAlt},
      {to: '/admin/billing', name: 'billingSubscription', icon: faFileInvoice},
      {to: '/admin/campaign', name: 'campaign', icon: faBell},
    ];
    break;
  case ROLES.USER:
    routes = [
      {to: '/admin/brands', name: 'myBrands', icon: faStore},
      {to: '/admin/tickets', name: 'receiptsByDate', icon: faReceipt},
      {to: '/admin/tickets/export', name: 'exportReceipts', icon: faFileExport},
      {to: '/admin/billing', name: 'premiumSubscription', icon: faFileInvoice},
      {to: '/admin/profile', name: 'profile', icon: faAddressCard},
    ];
    break;
  case ROLES.CENTRAL_PURCHASING:
    routes = [
      {to: '/admin/profile', name: 'profile', icon: faAddressCard},
    ];
    break;
  default:
    routes = [];
  }
  return routes;
}

export function getPrimaryRoute(role = ROLES.USER) {
  switch (role) {
  case ROLES.ADMIN:
  case ROLES.MERCHANT:
    return '/admin/dashboard';
  case ROLES.USER:
    return '/admin/brands';
  default:
    return '/admin/profile';
  }
}

export function checkErrorType(error, type) {
  return error && error.graphQLErrors && error.graphQLErrors.find((error) => error && error.extensions && error.extensions.exception && error.extensions.exception.name === type);
}

export function dateFormatFR({date}) {
  return moment(date).format('DD/MM/YYYY');
}

export function birthDateToAge(date) {
  return moment(date).isValid() ? moment().diff(moment(date), 'year') : 0;
}

export const numberFormatThousands = (num) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
};

export const isPdf = file => {
  return file.mimeType === FILE_TYPE.PDF;
};
